import { IBoxTransferPersistence, IBoxTransferUser } from '../interfaces';

export class BoxTransferMapper {
  public static toDomain(data: IBoxTransferPersistence): IBoxTransferUser {
    return {
      id: data.id,
      declaration: {
        id: data.declaration.id,
        trackCode: data.declaration.track_code,
      },
      fromContainer: {
        id: data.from_container.id,
        name: data.from_container.name,
      },
      toContainer: {
        id: data.to_container.id,
        name: data.to_container.name,
      },
      user: {
        id: data.user.id,
        name: data.user.name,
      },
      branch: {
        id: data.branch.id,
        name: data.branch.name,
      },
      note: data.note,
      createdAt: data.created_at,
    };
  }
}
